import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import packageConf from '../../package.json';
import { MediaMatcher } from '@angular/cdk/layout';
import { UIService } from './shared/services/ui-service.service';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent implements OnInit {
  mobileQuery: MediaQueryList;
  readonly mobileQueryListener: () => void;

  constructor(
    readonly media: MediaMatcher,
    readonly changeDetectorRef: ChangeDetectorRef,
    readonly uiService: UIService,
    readonly modalService: MatDialog,
    readonly router: Router,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 750px)');
    this.uiService.setIsMobile(!!this.mobileQuery.matches);
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.onchange = () => {
      this.uiService.setIsMobile(!!this.mobileQuery.matches);
    };
  }

  async ngOnInit() {
    console.log('ENV:', environment);
    console.log('VERSION:', packageConf.version);
    if (!environment.production) {
      let adminPass = window.sessionStorage.getItem('adminPass');
      if (!adminPass) {
        const { EnvModalComponent } =
          await import('./ui-common/components/env-modal/env-modal.component');
        this.modalService.open(EnvModalComponent, { disableClose: true });
      }
    } else {
      let gtag = window['gtag'];
      if (!gtag) {
        let analytics = document.createElement('script');
        analytics.type = 'text/javascript';
        analytics.src =
          'https://www.googletagmanager.com/gtag/js?id=' +
          environment.gAnalyticsId;

        analytics.async = true;
        document.body.appendChild(analytics);

        let ads = document.createElement('script');
        ads.type = 'text/javascript';
        ads.src =
          'https://www.googletagmanager.com/gtag/js?id=' + environment.gAdsId;

        ads.async = true;
        document.body.appendChild(ads);

        window['dataLayer'] = window['dataLayer'] || [];
        function gtag(param1?, param2?, param3?) {
          window['dataLayer'].push(arguments);
        }
        gtag('js', new Date());

        gtag('config', environment.gAnalyticsId);
        gtag('config', environment.gAdsId);

        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            gtag('config', environment.gAnalyticsId, {
              page_path: event.urlAfterRedirects,
            });
            gtag('event', 'conversion', { send_to: environment.gAdsKey });
          }
        });
      }
    }
    const redirectUrlSEO = window.sessionStorage.getItem('redirectUrlSEO');
    if (redirectUrlSEO) {
      window.sessionStorage.removeItem('redirectUrlSEO');
      this.router.navigateByUrl(`/${redirectUrlSEO}`, { replaceUrl: true });
    }
  }
}
